import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FullCalendarModule } from '@fullcalendar/angular';
import { HttpClientModule } from '@angular/common/http';
import { ClientsRoutingModule } from './clients-routing.module';

import { ClientsComponent } from './clients.component';
import { LandingComponent } from './landing/landing.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { BiographyComponent } from './biography/biography.component';
import { BudgetComponent } from './budget/budget.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { QuotesComponent } from './quotes/quotes.component';
import { ServicesComponent } from './services/services.component';
import { QuotesTwoComponent } from './quotes-two/quotes-two.component';
import { OurWorkComponent } from './our-work/our-work.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { SliderComponent } from './slider/slider.component';
import { MapsComponent } from './maps/maps.component';
import { FooterComponent } from './footer/footer.component';
import { CabeceraComponent } from './cabecera/cabecera.component';
import { ContactoComponent } from './contacto/contacto.component';
import { CookiesComponent } from './cookies/cookies.component';
import { DatosService } from './servicios/datos.service';
import { MenuComponent } from './menu/menu.component';


@NgModule({
  declarations: [
    LandingComponent,
    BiographyComponent,
    AppointmentsComponent,
    BudgetComponent,
    CabeceraComponent,
    ContactoComponent,
    CookiesComponent,
    AboutUsComponent,
    QuotesComponent,
    ServicesComponent,
    QuotesTwoComponent,
    OurWorkComponent,
    ScheduleComponent,
    SliderComponent,
    MapsComponent,
    FooterComponent,
    ClientsComponent,
    MenuComponent
  ],
  imports: [
    CommonModule,
    ClientsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FullCalendarModule,
    HttpClientModule
  ],
  providers: [
    DatosService
  ]
})
export class ClientsModule { }
